import type { NavigationContext } from "../flowConfig";

/**
 * Step conditions for the OLB flow that additionally skip a step when a portal-launched
 * application already has the data prefilled (copied from the applicant's most recent
 * prior application). The `hasPrefilled*` flags default to false, so an application that
 * was not prefilled — or whose prefill was incomplete — still shows the step. This keeps
 * the token-bootstrap OLB entry (which only prefills identity, not income/employment/
 * housing) unchanged.
 */

export function showOlbLivingArrangementStep(context: NavigationContext): boolean {
  return (context.showLivingArrangementStep ?? true) && !context.hasPrefilledLivingArrangement;
}

export function showOlbAddIncomeStep(context: NavigationContext): boolean {
  return !context.hasPrefilledIncome;
}

export function showOlbEmploymentDetailsStep(context: NavigationContext): boolean {
  return (context.showEmploymentDetailsStep ?? true) && !context.hasPrefilledEmployment;
}
